export const FORM_INITIAL_VALUES = {
  uploadFinancialStatement: null,
  formDate: null,
};
